__webpack_require__.p = "/shruti-portfolio/";